import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Card, CardBody, Container } from "reactstrap";
import SwiperCore, { Autoplay } from "swiper";

import SettingsSkeleton from "../../Components/Skeletons/SettingsSkeleton";
import CrowdFundCenter from "./CrowdFundCenter";

const SimplePage = () => {
  SwiperCore.use([Autoplay]);

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  document.title = "Profile";

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <SettingsSkeleton>
            <div className="page-content">
              <Container fluid>
                <CrowdFundCenter />
              </Container>
            </div>
          </SettingsSkeleton>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default SimplePage;
